module.exports = __webpack_public_path__ + "img/bgAbout.30211eea.png";